import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
  data: [],
  loading: false,
  error: null,
  initialData: [],
});

const actions = {
  async noteDragData({ commit }, data) {
    try {
      commit('labelUpdateBegin');
      commit('labelUpdateSuccess', data);
    } catch (err) {
      commit('labelUpdateErr', err);
    }
  },

  async noteReadAll({commit}, payload) {
    try {
        await commit('noteReadBegin');
        const response = await DataService.get(`/notes?${new URLSearchParams(payload).toString()}`);
        await commit('noteReadSuccess', response.data.data.list);
    } catch (err) {
        commit('noteReadErr', err);
    }
  },

  async noteRead({commit}, id) {
    try {
        await commit('noteReadBegin');
        const response = await DataService.get(`/notes/${id}`);
        await commit('noteReadSuccess', response.data.data);
    } catch (err) {
        await commit('noteReadErr', err);
    }
  },

  async noteAdd({ commit }, data) {
      await commit('noteAddBegin');
      await DataService.post(`/notes`, data).then((response) => {
        commit('noteAddSuccess', response.data.data);

        notification.success({
          message: response.data.message
        });
      }).catch((err) => {
        commit('noteReadErr', err);
      });
  },

  async noteUpdate({ commit }, data) {
      await commit('noteUpdateBegin');
      await DataService.put(`/notes/${data.id}`, data).then((response) => {
        commit('noteUpdateSuccess', response.data.data);

        notification.success({
          message: response.data.message,
          placement: 'topRight'
        });
      }).catch((err) => {
        commit('noteReadErr', err);
      });
  },

  async noteDelete({ commit }, id) {
      await commit('noteDeleteBegin');
      await DataService.delete(`/notes/${id}`).then((response) => {
        commit('noteDeleteSuccess', id);

        notification.success({
          message: response.data.message,
          placement: 'topRight'
        });
      }).catch((err) => {
        commit('noteReadErr', err);
      });
  },

  async noteDraggable({ commit }, data) {
    try {
      commit('noteReadBegin');
      commit('noteReadSuccess', data);
    } catch (err) {
      commit('noteReadErr', err);
    }
  },

  async onStarUpdate({ commit }, { data, id }) {
    try {
      commit('starUpdateBegin');
      data.map((item) => {
        if (item.key === id) {
          const fav = item;
          if (item.stared) {
            fav.stared = true;
          } else {
            fav.stared = false;
          }
        }
      });
      return commit('starUpdateSuccess', data);
    } catch (err) {
      commit('starUpdateErr', err);
    }
  },

  async onLabelUpdate({ commit }, { data, id, value }) {
    console.log("data", data , "id", id, "value", value);
    try {
      commit('labelUpdateBegin');

    } catch (err) {
      commit('labelUpdateErr', err);
    }
  },

  async onLabelFilter({ commit }, label) {
    try {
      commit('labelUpdateBegin');

      commit('labelUpdateSuccess', label);
    } catch (err) {
      console.log(err);
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
};